import { render } from "./DneMarket.vue?vue&type=template&id=65d36dae&scoped=true"
import script from "./DneMarket.vue?vue&type=script&lang=js"
export * from "./DneMarket.vue?vue&type=script&lang=js"

import "@/assets/scss/_entitiesPage.scss?vue&type=style&index=0&id=65d36dae&lang=scss&scoped=true"
import "./custom-market.scss?vue&type=style&index=1&id=65d36dae&lang=scss&scoped=true"
import "./DneMarket.vue?vue&type=style&index=2&id=65d36dae&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d36dae"]])

export default __exports__